// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"781":"08b99894","2706":"08b99894","3091":"08b99894","5472":"08b99894","8153":"08b99894"}[chunkId] + ".chunk.css";
};